module.exports = __webpack_public_path__ + "static/media/sxp-logo-black-2.fd223220.png";